import { render } from "./w-title.vue?vue&type=template&id=1664d634"
import script from "./w-title.vue?vue&type=script&lang=js"
export * from "./w-title.vue?vue&type=script&lang=js"

import "./w-title.vue?vue&type=style&index=0&id=1664d634&lang=scss&scope=true"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__